import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import _ from 'lodash';

import { toggleAudio } from 'actions/audioActions';
import { formatHtmlForPlay, isMobileAppRuntime } from 'utils';
import { imagesURL, audioURL } from 'config';
import getLocaleAudioFolderName from 'utils/getLocaleAudioFolderName';

class LoginHelp extends Component {
  state = {
    helpHtml: '',
    helpAudio: '',
    stringNumber: 1
  };

  componentDidMount() { 
    this.setStringNumber(); 
    this.setHelpHtml();
    this.setHelpAudio();
  }

  componentDidUpdate(prevProps, prevState) {
    const { translate, strings, lang, product } = this.props;   
    const { stringNumber } = this.state;
  
    if (prevProps.translate !== translate) {
      this.setHelpHtml();
    }
  
    if (prevProps.strings !== strings) {
      this.setHelpAudio();
    }
  
    if (prevProps.lang !== lang) {
      console.debug('Language changed, updating help audio...');
      this.setHelpAudio();
    }

    if (prevProps.product !== product)
      this.setStringNumber();

    if (prevState.stringNumber !== stringNumber) {     
      this.setHelpHtml();
      this.setHelpAudio();
    }

    console.debug('product, stringNumber:', [product, stringNumber]);
  }

  setStringNumber = () => {
    const { product } = this.props;
    if (product?.onePerson) this.setState({ stringNumber: 2657 });
  }

  setHelpHtml = () => {
    const { translate } = this.props;
    const { stringNumber } = this.state;

    const helpHtml = formatHtmlForPlay({
      html: translate(stringNumber, '', false, true),
      units: 'vw',
      calc: (size) => (size / 1360) * 100,
    });
    this.setState({ helpHtml });
  };

  setHelpAudio = () => {
    const { lang, strings } = this.props;
    const { stringNumber } = this.state;

    console.debug('Setting help audio...');
    console.debug('Current lang:', lang);
    console.debug('Strings:', strings);
  
    const langCode = lang?.code || 'en';
    const langName = getLocaleAudioFolderName(lang);
  
    const string = _.find(
      strings,
      (item) => Number(item?.stringNumber) === Number(stringNumber),
    );
    console.debug('Found string object:', string);
  
    if (!string) {
      console.warn('No string found for stringNumber: ', stringNumber);
      return;
    }
  
    const helpAudio = _.get(string, `data.${langCode}.stringAudio`);
    console.debug('Audio for current language:', helpAudio);
    let audioPath = '';
  
    if (helpAudio) {
      audioPath = `${audioURL}/Generic/Strings/${langName}/${helpAudio}`;
      console.debug('Audio file path:', audioPath);      
    } else {
      console.warn(`Audio file not found for language code: ${langCode}`);
    }

    this.setState({ 
      helpAudio: audioPath,
    });
  }

  render() {
    const {
      lang,
      classes,
      stateAudioSrc,
      isPlaying,
      audioDebugMode,
    } = this.props;
    const { helpHtml, helpAudio } = this.state;
    
    const audioSrc = helpAudio || `${audioURL}/Generic/LoginHelp/${
      getLocaleAudioFolderName(lang)
    }/Online/LoginHelp.mp3`;

    const playBtnIcon = `${imagesURL}/Images/Login/play-button-purple.png`;

    return (
      <div className={classes.helpWrapper}>
        <div
          className={classes.helpText}
          dangerouslySetInnerHTML={{ __html: helpHtml }}
        />

        {audioSrc &&
          <div
            className={classnames(classes.playButton, {
              [classes.playing]: audioSrc === stateAudioSrc && isPlaying,
            })}
            onClick={() => toggleAudio(audioSrc)}
            title="Audio help"
          >
            <img src={playBtnIcon} alt="" />
            <span className={classes.pauseIcon}>&times;</span>
          </div>
        }
        {isMobileAppRuntime() && audioDebugMode && (
          <div style={{
            marginTop: 8,
            color: '#c62828',
            fontFamily: 'monospace',
            fontSize: 12,
            lineHeight: 1.35,
            overflowWrap: 'anywhere',
            userSelect: 'text',
          }}>
            Audio URL: {audioSrc || 'not configured'}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ status, audio, common }) => ({
  translate: status.translate,
  strings: common.strings,
  isPlaying: audio.isPlaying,
  stateAudioSrc: audio.audioSrc,
  audioDebugMode:
    common.config?.customContentSettings?.mobileWrapper?.audioDebugMode === true,
});

export default connect(mapStateToProps)(LoginHelp);
